import Vue from 'vue'
import Vuex from 'vuex'
import commonStore from '@/store/modules/commonStore.js'
import profileStore from '@/store/modules/profileStore.js'
import snackbarStore from '@/store/modules/snackbarStore.js'
import adminStore from '@/store/modules/adminStore.js'
import appStore from '@/store/modules/appStore.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
export default new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  modules: {
    app: appStore,
    common: commonStore,
    profile: profileStore,
    snackbar: snackbarStore,
    admin: adminStore,
  },
  plugins: [
    createPersistedState({
      paths: ['profile',],
    }),
  ],
})
